/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function n(n){return"Enter"===n||" "===n}export{n as isActivationKey};
